import { getLocaleId } from 'utils/getLocaleId'

export const getVariables = ({ page }) => {
  return {
    page,
    localeId: getLocaleId(),
  }
}
